module.exports = __webpack_public_path__ + "img/Postmodernisme_Tida_og_samfunnsforhold4.27643949.jpg";